import { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import PersonIcon from "@material-ui/icons/Person";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// import Navbar from "../../components/Navbar";
import styles from "./registerstyles.module.css";
// import logo from "../../assets/img/logo.png";
import logo from "../../assets/img/lusuku_logo_main.png";
import { signUpFailure } from "../../redux/userRedux";
import { toast } from "react-toastify";
import { authenticateWithGoogle, signup, fetchAuthOptions } from "../../redux/apiCalls";
import Layout from "../../components/Global/Layout";
import PhoneAuth from "../../components/PhoneAuth/PhoneAuth";
import { PHONE_COUNTRY, PHONE_PREFERRED } from "../../config/market";

const Register = () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID_AUTH_WEBAPP;
  const [authMethod, setAuthMethod] = useState("phone"); // 'phone' or 'email'
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
  });
  const [focusedInput, setFocusedInput] = useState(null);
  const [showPhoneAuth, setShowPhoneAuth] = useState(false);
  const [smsOtpEnabled, setSmsOtpEnabled] = useState(true);

  // const [error, setError] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const redirectUrl = new URLSearchParams(location.search).get("redirect") || "";
  // const isLoading = useSelector((state) => state.registerLoader.register);
  const { isFetching, mailSignUpError } = useSelector((state) => state.user);
  // console.log(isFetching, "isFetching??");
  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: clientId,
        scope: "",
      });
    }
    gapi.load("client: auth2", start);
  });

  useEffect(() => {
    let cancelled = false;
    fetchAuthOptions()
      .then((opts) => {
        if (cancelled || !opts) return;
        const enabled = opts.smsOtpEnabled !== false;
        setSmsOtpEnabled(enabled);
        // DELIBERATELY does NOT switch away from phone any more.
        //
        // It used to call setAuthMethod("email") here, which drops the customer
        // on the email + PASSWORD form. That is a dead end for the exact people
        // an SMS outage affects: phone-registered customers have never set a
        // password (the server returns PASSWORD_NOT_SET for them), so the
        // "fallback" could not be completed.
        //
        // The phone flow now handles the outage itself — the server reroutes
        // the code to the customer's email where it has one, and PhoneAuth asks
        // for an address where it doesn't. Switching away pre-emptively would
        // hide a path that works. `smsOtpEnabled` is still recorded so the UI
        // can show an advisory notice.

      })
      .catch(() => {
        if (!cancelled) setSmsOtpEnabled(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Handle Google Authentication Success
  const handleGoogleSuccess = async (response) => {
    const { accessToken } = response;
    try {
      await authenticateWithGoogle(dispatch, {
        accessToken,
      });
      // Success - user will be redirected
      if (redirectUrl) { history.replace(redirectUrl); return; }
      const { from } = location.state || { from: { pathname: "/" } };
      history.replace(from);
    } catch (error) {
      console.log(error, "Error from Google authentication...");
      toast.error("Failed to authenticate with Google. Please try again.");
    }
  };

  const onFailure = (res) => {
    // console.log("LOGIN FAILED! res :", res);
    toast.error(res);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup(dispatch, data);
      if (redirectUrl) { history.replace(redirectUrl); return; }
      const { from } = location.state || { from: { pathname: "/" } };
      history.replace(from);
    } catch (err) {
      console.log(err, "Error from Sign up...");
      dispatch(signUpFailure(err.message));
    }
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleStartPhoneAuth = (e) => {
    e.preventDefault();
    
    if (!data.name.trim()) {
      toast.error("Please enter your name");
      return;
    }
    
    if (!data.phoneNumber || data.phoneNumber.length < 10) {
      toast.error("Please enter a valid phone number");
      return;
    }

    setShowPhoneAuth(true);
  };

  const handlePhoneAuthSuccess = () => {
    // User is now logged in via PhoneAuth component
    if (redirectUrl) { history.replace(redirectUrl); return; }
    const { from } = location.state || { from: { pathname: "/" } };
    history.replace(from);
  };

  return (
    <Layout>
      <div className={styles.sign_nav_container}>
        {/* <Navbar /> */}
        <div className={styles.sign_container}>
          <div className={styles.sign_form_container}>
            <img src={logo} alt="logo" className={styles.logo_signin} />
            <div style={{ width: "100%" }}>
              <h1
                style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  margin: "0 0 8px 0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "'Poppins', sans-serif",
                  color: "#2c3e50",
                  letterSpacing: "-0.5px",
                }}
              >
                Create Account
              </h1>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  margin: "0 0 32px 0",
                  textAlign: "center",
                  fontFamily: "'Inter', sans-serif",
                  color: "#7f8c8d",
                }}
              >
                Join Lusuku to start shopping!
              </p>
              {isFetching && (
                <div
                  style={{
                    marginTop: "1rem",
                    fontStyle: "italic",
                    color: "#042940",
                  }}
                >
                  A minute, we are verifying your profile...
                </div>
              )}
              {/* NOT gated on `smsOtpEnabled`. It used to be, and with the
                  Login page's fallback removed (see the fetchAuthOptions
                  effect) that left NO branch to render on a market where SMS
                  is switched off server-side — lusuku.co.zm showed the logo,
                  "Create Account", and an empty card. The phone flow itself
                  survives an SMS outage (WhatsApp is the default channel, and
                  the server reroutes the code to email), so the form stays;
                  the outage is a notice, not a locked door. Mirrors Login. */}
              {!isFetching && authMethod === "phone" && !showPhoneAuth && (
                <form onSubmit={handleStartPhoneAuth} autoComplete="off">
                  {!smsOtpEnabled && (
                    <Typography
                      style={{
                        textAlign: "center",
                        marginBottom: "14px",
                        fontSize: "13px",
                        lineHeight: 1.45,
                        fontFamily: "'Inter', sans-serif",
                        color: "#856404",
                        backgroundColor: "#fff8e6",
                        border: "1px solid #ffe082",
                        borderRadius: "8px",
                        padding: "9px 12px",
                      }}
                    >
                      SMS is down right now — we'll send your code on WhatsApp. Email also works.
                    </Typography>
                  )}
                  <div className={styles.inputWrapper}>
                    <PersonIcon
                      className={styles.inputIcon}
                      style={{
                        color: focusedInput === "name" ? "#017109" : "#95a5a6",
                      }}
                    />
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={data.name}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("name")}
                      onBlur={() => setFocusedInput(null)}
                      className={styles.input}
                      required
                    />
                  </div>
                  <div className={styles.inputWrapper}>
                    <PhoneInput
                      country={PHONE_COUNTRY}
                      value={data.phoneNumber}
                      onChange={(phone) => setData({ ...data, phoneNumber: phone })}
                      inputClass={styles.phoneInput}
                      containerClass={styles.phoneInputContainer}
                      buttonClass={styles.phoneInputButton}
                      placeholder="Enter phone number"
                      enableSearch={true}
                      disableSearchIcon={false}
                      countryCodeEditable={false}
                      preferredCountries={PHONE_PREFERRED}
                    />
                  </div>
                  <button 
                    type="submit" 
                    className={styles.sign_button}
                    disabled={!data.name.trim() || !data.phoneNumber || data.phoneNumber.length < 10}
                    title={
                      !data.name.trim() 
                        ? "Please enter your name" 
                        : !data.phoneNumber || data.phoneNumber.length < 10 
                        ? "Please enter a valid phone number" 
                        : "Click to send OTP"
                    }
                  >
                    Send OTP
                  </button>
                  <Typography
                    style={{
                      textAlign: "center",
                      marginTop: "16px",
                      fontSize: "14px",
                      fontFamily: "'Inter', sans-serif",
                      color: "#7f8c8d",
                    }}
                  >
                    Or{" "}
                    <button
                      type="button"
                      onClick={() => setAuthMethod("email")}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#017109",
                        fontWeight: "600",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontFamily: "'Inter', sans-serif",
                        textDecoration: "underline",
                      }}
                    >
                      use email instead
                    </button>
                  </Typography>
                </form>
              )}
              {!isFetching && authMethod === "phone" && showPhoneAuth && (
                <div>
                  <PhoneAuth
                    onSuccess={handlePhoneAuthSuccess}
                    isSignup={true}
                    initialPhone={data.phoneNumber}
                    userName={data.name}
                    onUseEmailInstead={() => {
                      setShowPhoneAuth(false);
                      setAuthMethod("email");
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setShowPhoneAuth(false);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#7f8c8d",
                      fontSize: "13px",
                      fontFamily: "'Inter', sans-serif",
                      cursor: "pointer",
                      padding: "12px 0",
                      marginTop: "12px",
                      width: "100%",
                      transition: "all 0.2s ease",
                      borderRadius: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f8f9fa";
                      e.target.style.color = "#2c3e50";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#7f8c8d";
                    }}
                  >
                    ← Back to name & phone
                  </button>
                </div>
              )}
              {!isFetching && authMethod === "email" && (
                <form onSubmit={handleSubmit} autoComplete="off">
                  <div className={styles.inputWrapper}>
                    <PersonIcon
                      className={styles.inputIcon}
                      style={{
                        color: focusedInput === "name" ? "#017109" : "#95a5a6",
                      }}
                    />
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={data.name}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("name")}
                      onBlur={() => setFocusedInput(null)}
                      className={styles.input}
                      required
                    />
                  </div>
                  <div className={styles.inputWrapper}>
                    <EmailIcon
                      className={styles.inputIcon}
                      style={{
                        color: focusedInput === "email" ? "#017109" : "#95a5a6",
                      }}
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={data.email}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("email")}
                      onBlur={() => setFocusedInput(null)}
                      className={styles.input}
                      required
                    />
                  </div>
                  <div className={styles.inputWrapper}>
                    <LockIcon
                      className={styles.inputIcon}
                      style={{
                        color:
                          focusedInput === "password" ? "#017109" : "#95a5a6",
                      }}
                    />
                    <input
                      type="password"
                      name="password"
                      placeholder="Password"
                      value={data.password}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("password")}
                      onBlur={() => setFocusedInput(null)}
                      className={styles.input}
                      required
                    />
                  </div>
                  {mailSignUpError && (
                    <div className={styles.error_msg}>{mailSignUpError}*</div>
                  )}
                  <button 
                    type="submit" 
                    className={styles.sign_button}
                    disabled={!data.name.trim() || !data.email.trim() || !data.password}
                    title={
                      !data.name.trim() 
                        ? "Please enter your name" 
                        : !data.email.trim() 
                        ? "Please enter your email" 
                        : !data.password 
                        ? "Please enter a password" 
                        : "Click to sign up"
                    }
                  >
                    Sign Up
                  </button>
                  {/* Divider */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "24px 0 20px 0",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        height: "1px",
                        backgroundColor: "#e0e0e0",
                      }}
                    ></div>
                    <span
                      style={{
                        padding: "0 16px",
                        fontSize: "13px",
                        color: "#95a5a6",
                        fontFamily: "'Inter', sans-serif",
                        fontWeight: 500,
                      }}
                    >
                      OR
                    </span>
                    <div
                      style={{
                        flex: 1,
                        height: "1px",
                        backgroundColor: "#e0e0e0",
                      }}
                    ></div>
                  </div>
                  {/* Google Authentication Button */}
                  <div id="googleSignin">
                    <GoogleLogin
                      clientId={clientId}
                      buttonText="Continue with Google"
                      onSuccess={handleGoogleSuccess}
                      onFailure={onFailure}
                      cookiePolicy="single_host_origin"
                      className={styles.google_sign_button}
                    />
                  </div>
                  {/* Sign In Section */}
                  <Typography
                    style={{
                      textAlign: "center",
                      marginTop: "24px",
                      fontSize: "14px",
                      fontFamily: "'Inter', sans-serif",
                      color: "#7f8c8d",
                    }}
                  >
                    Already have an account?{" "}
                    <Link
                      to={redirectUrl ? `/login?redirect=${encodeURIComponent(redirectUrl)}` : "/login"}
                      style={{
                        textDecoration: "none",
                        color: "#017109",
                        fontWeight: "600",
                        transition: "color 0.2s ease",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#015a07")}
                      onMouseLeave={(e) => (e.target.style.color = "#017109")}
                    >
                      Sign in
                    </Link>
                  </Typography>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
